import { render, staticRenderFns } from "./EntranceSetting.vue?vue&type=template&id=3c34c318&"
import script from "./EntranceSetting.vue?vue&type=script&lang=js&"
export * from "./EntranceSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports